import { render, staticRenderFns } from "./SoporteTecnico.vue?vue&type=template&id=310ccdb0&scoped=true"
import script from "./SoporteTecnico.vue?vue&type=script&lang=js"
export * from "./SoporteTecnico.vue?vue&type=script&lang=js"
import style0 from "./SoporteTecnico.vue?vue&type=style&index=0&id=310ccdb0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "310ccdb0",
  null
  
)

export default component.exports